import React from "react";
import PropTypes from "prop-types";

function createMarkup(htmlstring) { return {__html: htmlstring}; }

export default class InTheNewsCard extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    const { index, loading } = this.props;

    if (0 == index && !loading) {
      this.itemWrapper.focus();
    }
  }

  render() {
    const { displaytypename, publisheddate, displaydate, source, title, url, metalinks } = this.props;

    return (
      <div className="digest-card">
        { title && <div className="digest-card__title digest-card__title--search"><a ref={el => (this.itemWrapper = el)} href={ source.url }>{ title }</a></div>}
        { (displaydate || displaytypename) && <div className="digest-card__date">
            { displaydate && <span className="digest-card__label">
              { displaydate }
            </span> }
            { displaydate && displaytypename && <span> - </span>}
            { displaytypename && <span className="digest-card__label" dangerouslySetInnerHTML={ createMarkup(displaytypename) } />}
          </div> }
        { source && <div className="digest-card__items">
          <span className="digest-card__label">
            Source -&nbsp;
          </span>
          <a href={  source.url }>{  source.title }</a>
        </div> }
        { metalinks && <div dangerouslySetInnerHTML={createMarkup(metalinks)} />}
      </div>
    );
  }
}

const { bool, number, object, string } = PropTypes;

InTheNewsCard.propTypes= {
  displaytypename: string,
  index: number,
  loading: bool,
  publisheddate: string,
  displaydate: string,
  source: object,
  title: string,
  url: string
};
